import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
} from '@angular/core'

import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import { MatTooltipModule } from '@angular/material/tooltip'
import { MatTableModule, MatTableDataSource } from '@angular/material/table'

import { JsonPipe, NgClass, NgIf } from '@angular/common'

import { CnpjPipe } from '../../pipes/cpnj.pipes'
import { CpfPipe } from '../../pipes/cpf.pipes'
import { TelefonePipe } from '../../pipes/phone.pipes'
import { MatProgressSpinner } from '@angular/material/progress-spinner'

interface modelLoading {
  contract: boolean
  email: boolean
  download: boolean
  edit: boolean
  manager: boolean
  view: boolean
  remove: boolean
  cancelContract: boolean
  approveContract: boolean
  refuseContract: boolean
}

@Component({
  selector: 'table-list-contract',
  standalone: true,
  imports: [
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    MatTableModule,
    NgIf,
    CnpjPipe,
    CpfPipe,
    TelefonePipe,
    JsonPipe,
    MatProgressSpinner,
    NgClass,
  ],
  templateUrl: './table-list-contract.component.html',
  styleUrl: './table-list-contract.component.scss',
})
export class TableListContractComponent implements OnInit, OnChanges {
  constructor() {}

  @Input() dataSource: any[] = []
  @Input() columns: any[] = []
  @Input() spinLoad: modelLoading = {
    contract: false,
    email: false,
    download: false,
    edit: false,
    manager: false,
    view: false,
    remove: false,
    cancelContract: false,
    approveContract: false,
    refuseContract: false,
  }
  @Output() selectItem = new EventEmitter<any>()
  @Output() viewItem = new EventEmitter<any>()
  @Output() additionalOccurrenceItem = new EventEmitter<any>()
  @Output() downloadItem = new EventEmitter<any>()
  @Output() deleteItem = new EventEmitter<any>()
  @Output() managerItem = new EventEmitter<any>()
  @Output() sendContract = new EventEmitter<any>()
  @Output() sendEmail = new EventEmitter<any>()
  @Output() sendEmailOrcamento = new EventEmitter<any>()
  @Output() cancelContract = new EventEmitter<any>()
  @Output() approveContract = new EventEmitter<any>()
  @Output() refuseContract = new EventEmitter<any>()

  displayedColumns: string[] = []
  tableSource = new MatTableDataSource<any>()

  ngOnInit() {
    if (this.dataSource.length > 0) {
      this.displayedColumns = this.columns.map((obj: any) => obj.keyColumn)
      this.tableSource = new MatTableDataSource<any>(this.dataSource)
      this.updateTableDataSource()
    }
  }

  ngOnChanges() {
    this.updateTableDataSource()
  }

  private updateTableDataSource() {
    this.tableSource.data = this.dataSource
  }

  downloadItemEvent(item: any): void {
    this.downloadItem.emit(item)
  }

  viewItemEvent(item: any): void {
    this.viewItem.emit(item)
  }

  selectItemEvent(item: any): void {
    this.selectItem.emit(item)
  }

  deleteItemEvent(item: any): void {
    this.deleteItem.emit(item)
  }

  additionalOccurrenceEvent(item: any): void {
    this.additionalOccurrenceItem.emit(item)
  }

  sendContractEvent(item: any): void {
    this.sendContract.emit(item)
  }

  sendEmailEvent(item: any): void {
    this.sendEmail.emit(item)
  }

  sendEmailOrcamentoEvent(item: any): void {
    this.sendEmailOrcamento.emit(item)
  }

  managerItemEvent(item: any): void {
    this.managerItem.emit(item)
  }

  cancelContractEvent(item: any): void {
    this.cancelContract.emit(item)
  }

  approveContractEvent(item: any): void {
    this.approveContract.emit(item)
  }

  refuseContractEvent(item: any): void {
    this.refuseContract.emit(item)
  }
}
